import "./styles/CalculatorInputs.css";

interface SystemDetailsProps {
  results: {
    finalSystemSize: number;
    annualProductionKWh: number;
    actualOffsetKWh: number;
    grossSystemCost: number;
    taxCredit: number;
    finalSystemCost: number;
    solarLoanMonthly: number;
    annualSavings: number;
    totalSavings: number;
    pricePerWatt: number;
  };
  systemLife: string;
  isFinanced: boolean;
}

const formatNumber = (value: number): string =>
  value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default function SystemDetails({
  results,
  systemLife,
  isFinanced,
}: SystemDetailsProps) {
  return (
    <div className="system-details">
      <h2>System Details</h2>
      <div className="details-grid">
        <div className="detail-item">
          <h3>System Size</h3>
          <p>{formatNumber(results.finalSystemSize)} kW</p>
        </div>
        <div className="detail-item">
          <h3>Price Per Watt</h3>
          <p>${formatNumber(results.pricePerWatt)}</p>
        </div>
        <div className="detail-item">
          <h3>Annual Production</h3>
          <p>{formatNumber(results.annualProductionKWh)} kWh</p>
        </div>
        <div className="detail-item">
          <h3>Actual Offset</h3>
          <p>{formatNumber(results.actualOffsetKWh)} kWh</p>
        </div>
        <div className="detail-item">
          <h3>Total System Cost</h3>
          <p>${formatNumber(results.finalSystemCost)}</p>
        </div>
        {isFinanced && (
          <div className="detail-item">
            <h3>Monthly Loan Payment</h3>
            <p>${formatNumber(results.solarLoanMonthly)}</p>
          </div>
        )}
        <div className="detail-item">
          <h3>Annual Savings</h3>
          <p>${formatNumber(results.annualSavings)}</p>
        </div>
        <div className="detail-item full-width">
          <h3>{systemLife}-Year Total Savings</h3>
          <p>${formatNumber(results.totalSavings)}</p>
        </div>
      </div>
    </div>
  );
}
